var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInterfaceGlyphChecked = function SvgInterfaceGlyphChecked(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.412 20.5c-.392 0-.726-.138-1-.413A1.369 1.369 0 0 1 3 19.083V4.917c0-.394.137-.728.412-1.004a1.36 1.36 0 0 1 1-.413h14.117c.22 0 .42.047.6.142.18.094.326.204.436.33l-1.036 1.04v-.095H4.412v14.166h14.117v-8.098l1.412-1.417v9.515c0 .394-.137.728-.412 1.004a1.359 1.359 0 0 1-1 .413H4.412Zm6.612-3.967L5.8 11.292l.988-.992 4.236 4.25 8.988-9.02.988.992-9.976 10.011Z"
  })));
};
export default SvgInterfaceGlyphChecked;